import IMG_1_1 from 'assets/images/scooter/xl/img-xl-1.png'
import IMG_1_2 from 'assets/images/scooter/xl/img-xl-1_m.png'

import IMG_2_1 from 'assets/images/scooter/xl/img-xl-2.png'
import IMG_2_2 from 'assets/images/scooter/xl/img-xl-2_m.png'
import IMG_2_3 from 'assets/images/scooter/xl/Think_Big.png'

import IMG_3_1 from 'assets/images/scooter/xl/img-xl-3.png'
import IMG_3_2 from 'assets/images/scooter/xl/img-xl-3_m.png'
import IMG_3_3 from 'assets/images/scooter/xl/Extra_Comfort.png'
import IMG_3_4 from 'assets/images/scooter/xl/Extra_Comfort_m.png'

import IMG_4_1 from 'assets/images/scooter/xl/img-xl-4.png'
import IMG_4_2 from 'assets/images/scooter/xl/img-xl-4_m.png'

import IMG_5_1 from 'assets/images/scooter/xl/img-xl-5.png'
import IMG_5_2 from 'assets/images/scooter/xl/img-xl-5_m.png'

import IMG_6_1 from 'assets/images/scooter/xl/img-xl-6.png'
import IMG_6_2 from 'assets/images/scooter/xl/img-xl-6_m.png'

import IMG_7_1 from 'assets/images/scooter/xl/img-xl-7.png'
import IMG_7_2 from 'assets/images/scooter/xl/img-xl-7_m.png'
import IMG_7_3 from 'assets/images/scooter/xl/Extra_Safe.png'
import IMG_7_4 from 'assets/images/scooter/xl/Extra_Safe_m.png'

import IMG_8_1 from 'assets/images/prev_arrow.svg'
import IMG_8_2 from 'assets/images/next_arrow.svg'

import IMG_9_1 from 'assets/images/scooter/xl/img-xl-16.png'
import IMG_9_2 from 'assets/images/scooter/xl/img-xl-16_m.png'

import IMG_10_1 from 'assets/images/scooter/xl/img-xl-8.png'
import IMG_10_2 from 'assets/images/scooter/xl/img-xl-8_m.png'

import IMG_12_1 from 'assets/images/scooter/xl/img-xl-10_1.png'
import IMG_12_2 from 'assets/images/scooter/xl/img-xl-10_1_m.png'

import IMG_13_1 from 'assets/images/scooter/xl/img-xl-13_1.png'
import IMG_13_2 from 'assets/images/scooter/xl/img-xl-13_m.png'

import IMG_14_1 from 'assets/images/scooter/xl/img-xl-18.png'

import { URL, OUTER_URL } from '../../utils/Utils'
import ScooterXlImgSwiper from '../../components/swiper/ScooterXlImgSwiper'
import ScooterXlImgTwoSwiper from '../../components/swiper/ScooterXlImgTwoSwiper'
import './ScooterXl.scss'
import { useEffect, useState } from 'react'
import { MOBILE } from '../../utils/Utils'

/**
 * @file 고고로 VIVA XL 화면
 */
function ScooterXl() {
    // 사용자의 화면 너비
    const [width, setWidth] = useState(window.innerWidth)
    // 사용자의 화면 너비가 바뀔때마다 변수에 담아줌
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return (
        <>
            <div className="xl-one pc" style={{ backgroundImage: `url(${IMG_1_1})` }} />
            <div className="xl-one mobile" style={{ backgroundImage: `url(${IMG_1_2})` }} />
            <div className="xl-two">
                <div>
                    <div className="t1">고고로 비바 XL</div>
                    <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                        구매문의
                    </a>
                </div>
            </div>
            <div className="xl-three">
                <div className="text">
                    고고로 VIVA XL <br />
                    더욱 더 커진 수납공간
                    <br />
                    <br />
                    장거리 여행에 적합한
                    <br />
                    넓은 수납공간과 안정적인 주행성능
                </div>
            </div>
            <div className="xl-four pc" style={{ backgroundImage: `url(${IMG_2_1})` }}>
                <img className="textImg" src={IMG_2_3} alt="think big" />
            </div>
            <div className="xl-four mobile" style={{ backgroundImage: `url(${IMG_2_2})` }}>
                <img className="textImg" src={IMG_2_3} alt="think big" />
            </div>
            <div className="xl-five pc" style={{ backgroundImage: `url(${IMG_3_1})` }}>
                <img className="textImg" src={IMG_3_3} alt="" />
            </div>
            <div className="xl-five mobile" style={{ backgroundImage: `url(${IMG_3_2})` }}>
                <img className="textImg" src={IMG_3_4} alt="" />
            </div>

            <div className="xl-six">
                <div className="t1">
                    확장된 안장으로 더욱 편안하고
                    <br />
                    안정적인 주행 승차감
                </div>
                <div className="grid-box">
                    <div>
                        <div className="one img">
                            <img className="pc" src={IMG_4_1} alt="" />
                            <img className="mobile" src={IMG_4_2} alt="" />
                            <div className="text-box">
                                <div className="sub">810mm Extra Long Seat</div>
                                <div className="t1">여행과 레저를 위한{width <= MOBILE && <br />} 넓고 편안한 공간</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="one img">
                            <img className="pc" src={IMG_5_1} alt="" />
                            <img className="mobile" src={IMG_5_2} alt="" />
                            <div className="text-box">
                                <div className="sub">26.5 L Large Storage Space</div>
                                <div className="t1">행복한 추억을{width <= MOBILE && <br />} 가득 담을 넓은 공간</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="one img">
                            <img className="pc" src={IMG_6_1} alt="" />
                            <img className="mobile" src={IMG_6_2} alt="" />
                            <div className="text-box">
                                <div className="sub">260mm Leg Room</div>
                                <div className="t1">더욱 더 넓어진{width <= MOBILE && <br />} 발판공간</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="xl-seven">
                <div className="img pc" style={{ backgroundImage: `url(${IMG_7_1})` }}>
                    <img className="textImg" src={IMG_7_3} alt="" />
                </div>
                <div className="img mobile" style={{ backgroundImage: `url(${IMG_7_2})` }}>
                    <img className="textImg" src={IMG_7_4} alt="" />
                </div>
            </div>

            <div className="xl-eight">
                <div className="t1">소중한 사람의 안전을 위해</div>
                <div className="swiper-outer">
                    <button className="slide-control-btn prev">
                        <img src={IMG_8_1} alt="" />
                    </button>
                    <button className="slide-control-btn next">
                        <img src={IMG_8_2} alt="" />
                    </button>
                    <ScooterXlImgSwiper />
                </div>
            </div>

            <div className="xl-nine pc">
                <div className="textBox">다양한 주행 모드</div>
                <img src={IMG_9_1} alt="" />
            </div>

            <div className="xl-nine mobile">
                <img src={IMG_9_2} alt="" />
                <div className="textBox">다양한 주행 모드</div>
            </div>

            <div className="xl-ten">
                <div className="img pc" style={{ backgroundImage: `url(${IMG_10_1})` }}></div>
                <div className="img mobile" style={{ backgroundImage: `url(${IMG_10_2})` }}></div>
                <div className="text-box">
                    <div className="t1">
                        Extra
                        <br />
                        Thoughtful
                    </div>
                </div>
            </div>

            <div className="xl-eleven">
                <div className="t1 t1-red">
                    편의성은 물론
                    <br />
                    안전까지 생각했습니다.
                </div>
                <div className="swiper-outer">
                    <button className="slide-control-btn prev">
                        <img src={IMG_8_1} alt="" />
                    </button>
                    <button className="slide-control-btn next">
                        <img src={IMG_8_2} alt="" />
                    </button>
                    <ScooterXlImgTwoSwiper />
                </div>
            </div>

            <div className="xl-twelve pc">
                <div>
                    <div className="text-box">
                        {/* <div className="sub"></div> */}
                        {/* <div className="t1">오늘보다 내일 더 스마트한 기능</div> */}
                    </div>
                    <img src={IMG_12_1} alt="" />
                </div>
            </div>
            <div className="xl-twelve mobile">
                <div>
                    <div className="text-box">
                        {/* <div className="sub"></div> */}
                        {/* <div className="t1">오늘보다 내일 더 스마트한 기능</div> */}
                    </div>
                    <img src={IMG_12_2} alt="" />
                </div>
            </div>

            <div className="xl-thirteen pc" style={{ backgroundImage: `url(${IMG_13_1})` }}></div>
            <div className="xl-thirteen mobile" style={{ backgroundImage: `url(${IMG_13_2})` }}></div>

            <div className="xl-fourteen">
                <div className="xl-motors-wrapper">
                    <img src={IMG_14_1} alt="" />
                    <div className="t1">고고로 VIVA XL</div>
                    <div className="sub">BELT</div>
                    <div className="colors">
                        <span style={{ backgroundColor: '#be3d3d' }} />
                    </div>
                </div>
                <div className="details">
                    <div className="t1">디테일</div>
                    <div className="details-box">
                        <div>
                            <div className="box-row">
                                <div className="s1">길이 x 너비 x 높이 (백미러 제외)</div>
                                <div className="d1">1,845 x 665 x 1,095mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">휠베이스</div>
                                <div className="d1">1,298mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">안장 높이</div>
                                <div className="d1">750mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">무게 (비어 있음/배터리 포함)</div>
                                <div className="d1">96/114kg</div>
                            </div>
                        </div>
                        <div>
                            <div className="box-row">
                                <div className="s1">최대 전력</div>
                                <div className="d1">6.4kW @3,000rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">최대 토크 (모터/휠)</div>
                                <div className="d1">24 / 198Nm @ 0-2,500rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">등판성</div>
                                <div className="d1">
                                    30%(17°): 30km/h <br />
                                    20%(11°): 40km/h <br />
                                    10%(6°): 60km/h <br />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="extra-describes">
                        * 이 표는 참고용이며 테스트 시나리오에 따라 결과가 달라질 수 있습니다.
                        <br />* 자세한 정보는 고객센터를 통해 확인해주시기 바랍니다.
                    </div>
                </div>
            </div>
        </>
    )
}

export default ScooterXl
